module.exports = __webpack_public_path__ + "static/media/passaporte_coliseu.3d6dce31.webp";